module.exports = __webpack_public_path__ + "img/mobile_title.d6c8d953.png";